/* global axios */
import ApiClient from './ApiClient';

class ContactLabelsAPI extends ApiClient {
  constructor() {
    super('contact_labels', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(label) {
    return axios.post(this.url, label);
  }

  update(id, label) {
    return axios.patch(`${this.url}/${id}`, label);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getContactLabels(contactId) {
    return axios.get(`${super.baseUrl()}/contacts/${contactId}/labels`);
  }

  updateContactLabels(contactId, labels) {
    return axios.post(`${super.baseUrl()}/contacts/${contactId}/labels`, {
      labels,
    });
  }
}

export default new ContactLabelsAPI();
